import { computed, inject } from "vue";
import type {
  ICProdProvProvider,
  ICProdProvProviderMethods
} from "@/models/providers/contractProduct";

/**
 * Composable to inject contract product provisioning provider data and methods.
 */

export function useCProdProvInjector() {
  const cProdProvDataProvider =
    inject<() => ICProdProvProvider>("cProdProvProvider");
  const cProdProvMethodsProvider = inject<ICProdProvProviderMethods>(
    "cProdProvProviderMethods"
  );

  if (!cProdProvDataProvider) {
    throw new Error(
      "useCProdProvInjector must be used within a component that has a cProdProvProvider ancestor"
    );
  }

  const cProdProvData = computed(() => cProdProvDataProvider());

  return {
    cProdProvData,
    cProdProvMethods: cProdProvMethodsProvider
  };
}
